import React from "react";

import { BasicButton } from "@gaming/xds-react-js";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { StreamingEuStep, StreamingEuStepDefaultProps } from "../models";
import {
  StreamingButtonLabels,
  StreamingEuStepTitle,
  StreamingProviderLicenseContent,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";

export const StreamingProviderLicense = ({ navigateToStep }: StreamingEuStepDefaultProps) => {
  const navigateToUserEntitlementData = () => navigateToStep(StreamingEuStep.UserEntitlementData);
  return (
    <>
      <h1 className={styles.title}>{StreamingEuStepTitle.StreamingProviderLicense}</h1>
      <div className={styles.scrollBox}>{StreamingProviderLicenseContent}</div>
      <div className={styles.horizontalCentering}>
        <BasicButton
          as={"button"}
          onClick={navigateToUserEntitlementData}
          className={commonStyles.primaryButton}
          textDecorationUnderline={true}
        >
          {StreamingButtonLabels.Register}
        </BasicButton>
      </div>
    </>
  );
};
